// Function to process menu headings
function processMenuHeadings() {
    // Find all level 3 menu items that contain "(Bold Heading)"
    const level3Items = document.querySelectorAll('.navigation__tier-3 .navigation__item');
    
    level3Items.forEach(item => {
        const link = item.querySelector('.navigation__link');
        if (!link) return;
        
        const text = link.textContent.trim();
        
        // Check if the link text contains "Bold Heading"
        if (text.includes('Bold Heading')) {
            // Remove the "Bold Heading" text
            const cleanText = text.replace(/\s*Bold Heading\s*$/, '').trim();
            link.textContent = cleanText;
            
            // Add the custom class to the parent item or the link
            item.classList.add('cstm_mnu_head');
            // Also add to the link for styling
            link.classList.add('cstm_mnu_head_link');
            
            console.log('Processed heading:', cleanText); // For debugging
        }
    });
}

// Run after DOM is ready
document.addEventListener('DOMContentLoaded', function() {
    // Initial run
    processMenuHeadings();
    
    // Run after a short delay to catch any dynamically loaded content
    setTimeout(processMenuHeadings, 500);
    setTimeout(processMenuHeadings, 1000);
    
    // Set up observer for dynamic content
    if (document.body) {
        const observer = new MutationObserver(function(mutations) {
            let shouldProcess = false;
            mutations.forEach(function(mutation) {
                // Check if added nodes contain menu-related elements
                if (mutation.addedNodes.length) {
                    mutation.addedNodes.forEach(node => {
                        if (node.nodeType === 1) { // Element node
                            if (node.classList && (
                                node.classList.contains('navigation__tier-3') ||
                                node.querySelector && node.querySelector('.navigation__tier-3')
                            )) {
                                shouldProcess = true;
                            }
                        }
                    });
                }
            });
            
            if (shouldProcess) {
                processMenuHeadings();
            }
        });
        
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }
});

// Also run when navigation menus are opened (for lazy-loaded content)
document.addEventListener('mouseenter', function(e) {
    if (e.target.closest('.navigation__item--with-mega-menu')) {
        setTimeout(processMenuHeadings, 100);
    }
}, true);
